import {
  CuraBadgePill,
  CuraButton,
  CuraHeading,
  CuraIcon,
  CuraLabel,
  CuraModal,
  CuraParagraph
} from '@rededor/cura-react'
import { usePrefilledSummaryStore } from '@/store/usePrefilledSummaryStore'
import { useScheduleStore } from '@/store/useScheduleStore'
import { formatBirthDate } from '@/utils/helpers/formatBirthdate'
import { getGenderFormated } from '@/utils/helpers/scheduleUtils'

import * as S from './styles'

export const PrefilledSummary = () => {
  const healthCarrier = useScheduleStore((state) => state.healthCarrier)
  const healthPlan = useScheduleStore((state) => state.healthPlan)
  const location = useScheduleStore((state) => state.location)
  const patient = useScheduleStore((state) => state.patient)
  const product = useScheduleStore((state) => state.product)

  const setShow = usePrefilledSummaryStore.getState().setShow
  const showPrefilledSummary = usePrefilledSummaryStore((state) => state.show)
  const ruleId = usePrefilledSummaryStore((state) => state.ruleId)

  const hasValidData = [healthPlan, location, product].some(Boolean)
  const canShowPrefilledSummary = Boolean(showPrefilledSummary && hasValidData)

  const handleClick = () => {
    setShow(false)
  }

  const texts = {
    title:
      ruleId === 2
        ? 'Agende em poucos cliques a consulta indicada pelo seu médico.'
        : 'Seu novo agendamento está a poucos cliques.',
    action: ruleId === 2 ? 'AGENDE SUA CONSULTA' : 'ESCOLHA UMA NOVA DATA'
  }

  return (
    <CuraModal open={canShowPrefilledSummary} canClose={false}>
      <S.Content>
        <S.Heading>
          <CuraParagraph size="medium" color="neutral-black" marginBlock="0">
            <strong>{texts.title}</strong>
          </CuraParagraph>
          <S.IconText>
            <CuraIcon name="calendar" color="neutral-dark" size={16} />
            <CuraLabel size="xsmall" color="neutral-black">
              Resumo do seu pedido:
            </CuraLabel>
          </S.IconText>
        </S.Heading>
        <S.Info>
          {product && (
            <S.Item>
              <CuraBadgePill color="secondary">Especialidade</CuraBadgePill>
              <CuraParagraph
                size="small"
                color="neutral-black"
                marginBlock="8px"
              >
                <strong>{product.name}</strong>
              </CuraParagraph>
            </S.Item>
          )}
          {location && (
            <S.Item>
              <CuraBadgePill color="primary">Local</CuraBadgePill>
              <CuraParagraph
                size="small"
                color="neutral-black"
                marginBlock="8px"
              >
                <strong>{location.name}</strong>
              </CuraParagraph>
            </S.Item>
          )}
          {healthCarrier && healthPlan && (
            <S.Item>
              <CuraBadgePill color="neutral">Pagamento</CuraBadgePill>
              <S.Columns>
                <S.ColumnItem>
                  <CuraHeading
                    size="xsmall"
                    color="neutral-dark"
                    marginBlock="0"
                  >
                    Convênio:
                  </CuraHeading>
                  <CuraParagraph
                    size="xsmall"
                    color="neutral-black"
                    marginBlock="0"
                  >
                    <strong>{healthCarrier.name}</strong>
                  </CuraParagraph>
                </S.ColumnItem>
                <S.ColumnItem>
                  <CuraHeading
                    size="xsmall"
                    color="neutral-dark"
                    marginBlock="0"
                  >
                    Plano:
                  </CuraHeading>
                  <CuraParagraph
                    size="xsmall"
                    color="neutral-black"
                    marginBlock="0"
                  >
                    <strong>{healthPlan.name}</strong>
                  </CuraParagraph>
                </S.ColumnItem>
              </S.Columns>
            </S.Item>
          )}
          {(patient?.birthDate || patient?.gender) && (
            <S.Item>
              <CuraBadgePill color="neutral">Paciente</CuraBadgePill>
              <S.Columns $spaceBetween>
                {patient.birthDate && (
                  <S.ColumnItem>
                    <CuraHeading
                      size="xsmall"
                      color="neutral-dark"
                      marginBlock="0"
                    >
                      Data de nascimento:
                    </CuraHeading>
                    <CuraParagraph
                      size="xsmall"
                      color="neutral-black"
                      marginBlock="0"
                    >
                      <strong>{formatBirthDate(patient.birthDate)}</strong>
                    </CuraParagraph>
                  </S.ColumnItem>
                )}
                {patient.gender && (
                  <S.ColumnItem>
                    <CuraHeading
                      size="xsmall"
                      color="neutral-dark"
                      marginBlock="0"
                    >
                      Sexo biológico:
                    </CuraHeading>
                    <CuraParagraph
                      size="xsmall"
                      color="neutral-black"
                      marginBlock="0"
                    >
                      <strong>{getGenderFormated(patient.gender)}</strong>
                    </CuraParagraph>
                  </S.ColumnItem>
                )}
              </S.Columns>
            </S.Item>
          )}
        </S.Info>
        <S.IconText $alignTop>
          <CuraIcon name="infoCircle" size={16} color="info-dark" />
          <CuraParagraph size="xsmall" color="info-dark" marginBlock="0">
            <span>
              <strong>Lembre-se:</strong> ao avançar no agendamento, você poderá
              editar os dados do pedido.
            </span>
          </CuraParagraph>
        </S.IconText>
        <CuraButton
          size="medium"
          color="primary"
          fontColor="light"
          style={{ width: '100%' }}
          onClick={handleClick}
        >
          {texts.action}
        </CuraButton>
      </S.Content>
    </CuraModal>
  )
}
